import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';


@Component({
    selector: 'app-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss'],
    standalone: false
})
export class LabelComponent extends BaseControlComponent implements OnInit {
    static componentName = 'LabelComponent';

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {

    }
}